import { reportApi } from 'api';
import { TReport } from 'modules/core/types';
import { ReportType } from 'modules/core/enums';

export class ReportService {
  static async printReport(reportData: TReport, reportType: ReportType): Promise<void> {
    const { data: reportBlob } = await reportApi.postPrintReport(reportData, reportType);

    this.openReport(reportBlob);
  }

  static downloadReport(fileBlob: Blob, fileName: string) {
    const fileURL = URL.createObjectURL(fileBlob);
    const link = document.createElement('a');

    link.href = fileURL;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(fileURL);
  }

  private static openReport(reportBlob: Blob): void {
    const fileURL = URL.createObjectURL(reportBlob);

    window.open(fileURL);
  }
}
